import { prop } from 'ramda';
import { useCallback, useMemo } from 'react';
import { usePrevious } from 'js/hooks/usePrevious';
import { useUpdateEffect } from 'js/hooks/useUpdateEffect';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from './store';

import * as actions from './store/actions';

export const useSliderNavigation = () => {
    const dispatch = useDynamicReducerDispatch();
    const activeSlide = useDynamicReducerSelector(prop('activeSlide'));

    return {
        sliderMove: useCallback(nextSlide => {
            return dispatch(actions.sliderMove({ activeSlide: nextSlide, prevSlide: activeSlide }));
        }, [activeSlide, dispatch]),
        sliderMoveRight: useCallback(() => dispatch(actions.sliderMoveRight()), [dispatch]),
        sliderMoveLeft: useCallback(() => dispatch(actions.sliderMoveLeft()), [dispatch])
    };
};

export const useActiveSlideChangeEffect = ({ onActiveSlideChange, sliderState }) => {
    const { activeSlide, prevSlide } = sliderState;
    const prevActiveSlide = usePrevious(activeSlide);

    useUpdateEffect(() => {
        if (prevSlide === prevActiveSlide) {
            onActiveSlideChange && onActiveSlideChange(sliderState);
        }
    }, [activeSlide]);
};

export const useArrowStyles = ({ position: top }) => useMemo(
    () => top ? { top } : {},
    [top]
);

export const useBulletsClassNames = ({ bullet, bullets, activeBullet: active }) => useMemo(
    () => ({ bullet, bullets, active }),
    [bullet, bullets, active]
);

export const useBulletClickHandler = () => {
    const { sliderMove } = useSliderNavigation();
    const activeSlide = useDynamicReducerSelector(prop('activeSlide'));

    return useCallback((nextSlide) => {
        if (nextSlide !== activeSlide) {
            sliderMove(nextSlide);
        }
    }, [activeSlide, sliderMove]);
};

export const useSliderMouseEventHandlers = ({
    slidesCount,
    showControlsOnHover,
    setIsHover
}) => {
    const toggleHover = useCallback((value) => {
        if (showControlsOnHover && slidesCount > 1) {
            setIsHover(value);
        }
    }, [setIsHover, showControlsOnHover, slidesCount]);

    return {
        onMouseEnter: () => toggleHover(true),
        onMouseLeave: () => toggleHover(false)
    };
};

